export enum Socket {
	REFRESH_DASHBOARD_MESSAGES = 'refreshDashboardMessages',
}
